import React from 'react'

const List = () => {
  return (
    <div className="bg-white border rounded-xl p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-semibold theme-text-primary">Lists</h2>
      <div className="mt-4 text-gray-600">You have no saved lists.</div>
    </div>
  )
}

export default List

